<template>
  <div>
    <input
      type="text"
      class="w-full form-control form-input form-input-bordered form-input--small"
      :placeholder="$t('Enter number')"
      :value="item.response"
      @change="handleChange"
      @keyup="handleChange"
    >
  </div>
</template>

<script>

  export default {

    components: {},

    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {},

    methods: {
      handleChange(event) {
        const value = event.target.value.replace(',', '.');
        this.$store.commit('conduct/changeResponse', {
          item: this.item.uuid,
          response: value,
          responded: value !== '',
        });
      },
    },
  };
</script>
